var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8182 8.92933L12.5343 10.6454C12.7915 10.9026 12.7915 11.3196 12.5343 11.5768C11.1439 12.9672 8.94265 13.1237 7.36955 11.9438L6.56953 11.3438C5.08626 10.2314 3.76864 8.91374 2.65619 7.43048L2.05617 6.63045C0.876349 5.05735 1.03279 2.8561 2.42322 1.46567C2.6804 1.20849 3.09738 1.20849 3.35456 1.46567L5.07067 3.18178C5.46119 3.57231 5.46119 4.20547 5.07067 4.596L4.52959 5.13707C4.41239 5.25428 4.38333 5.43333 4.45746 5.58158C5.31449 7.29565 6.70435 8.68551 8.41842 9.54254C8.56667 9.61667 8.74572 9.58761 8.86293 9.47041L9.404 8.92933C9.79453 8.5388 10.4277 8.53881 10.8182 8.92933Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call_icon.a8929cc6f81986e956ff6d7c3284b4ee.svg";
export { ForwardRef as ReactComponent };